"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerModal = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var import_ctrl_1 = require("../../page/import/import.ctrl");
var CSS = {
    result: 'c-ImportMapper__result'
};
var Style = (_a = {},
    _a[CSS.result] = {
        'padding-bottom': theme_1.DefaultTheme.space(2)
    },
    _a);
(0, theme_1.addStyles)(Style);
var SpinnerModal = /** @class */ (function (_super) {
    tslib_1.__extends(SpinnerModal, _super);
    function SpinnerModal(ctx) {
        var _this = _super.call(this, ctx) || this;
        _this.results = [];
        _this.displaySubmitButton = false;
        _this.displayCancelButton = false;
        return _this;
    }
    Object.defineProperty(SpinnerModal.prototype, "nodes", {
        get: function () {
            if (this.results.length) {
                return (0, mithril_1.m)('div', this.results.map(function (result) { return (0, mithril_1.m)('div', { className: CSS.result }, result); }));
            }
            return (0, mithril_1.m)('div', { className: import_ctrl_1.CSS.spinner }, spinner_1.Spinner.view());
        },
        enumerable: false,
        configurable: true
    });
    SpinnerModal.prototype.setModalResult = function (results) {
        this.results = results;
        this.displayCancelButton = true;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], SpinnerModal.prototype, "results", void 0);
    return SpinnerModal;
}(modal_form_component_1.ModalFormComponent));
exports.SpinnerModal = SpinnerModal;
//# sourceMappingURL=spinner.modal.js.map